import { createContext } from 'react';

type QuotaResource = 'documents' | 'analysis runs';

export interface QuotaBlockContextValue {
  /**
   * Inspect a caught error; if it is a server-side quota block (HTTP 402 with
   * a known quota error code), open the block dialog and return `true`.
   * Otherwise return `false` so the caller can keep its existing error flow.
   */
  readonly handleQuotaError: (error: unknown) => boolean;
  /**
   * Manually open the dialog — used by the upload page's client-side
   * pre-check that anticipates a 402 before submitting.
   */
  readonly openQuotaBlock: (resource: QuotaResource) => void;
}

export const QuotaBlockCtx = createContext<QuotaBlockContextValue | null>(null);
